import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createModelCode } from '../model-code/ModelCode';

/**
 * # DeptRestructure
 *
 * 조직 개편 이벤트 이력 모델 (TB_DEPT_RESTRUCTURE)
 */
export const DeptRestructure = types
  .model('DeptRestructure')
  // --------------------------------------------------------------------------
  .props({
    restructureSid: types.optional(types.number, 0),
    restructureTypeCd: types.maybeNull(types.union(types.number, createModelCode())),
    restructureTypeNm: types.maybeNull(types.optional(types.string, '')),
    eventDt: types.maybeNull(types.union(types.number, types.string)),
    fiscalYearFrom: types.optional(types.number, 0),
    fiscalYearTo: types.maybeNull(types.optional(types.number, 0)),
    description: types.maybeNull(types.optional(types.string, '')),
    approvalStatusCd: types.maybeNull(types.union(types.number, createModelCode())),
    approvalStatusNm: types.maybeNull(types.optional(types.string, '')),
    requestedBy: types.maybeNull(types.union(types.number, types.frozen())),
    requestedDt: types.maybeNull(types.union(types.number, types.string)),
    approvedBy: types.maybeNull(types.union(types.number, types.frozen())),
    approvedDt: types.maybeNull(types.union(types.number, types.string)),
    scheduledDt: types.maybeNull(types.union(types.number, types.string)),
    executedDt: types.maybeNull(types.union(types.number, types.string)),
    rejectReason: types.maybeNull(types.optional(types.string, '')),
    snapshotData: types.maybeNull(types.optional(types.string, '')),
    mappings: types.maybeNull(types.union(types.array(types.frozen()), types.frozen())),
    regDt: types.maybeNull(types.optional(types.number, 0)),
    regId: types.maybeNull(types.union(types.number, types.frozen())),
    regUser: types.maybeNull(types.frozen()),
    updDt: types.maybeNull(types.optional(types.number, 0)),
    updId: types.maybeNull(types.union(types.number, types.frozen())),
    updUser: types.maybeNull(types.frozen()),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IDeptRestructure;
      (Object.keys(newProps) as TDeptRestructureKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TDeptRestructure = Instance<typeof DeptRestructure>;
type TDeptRestructureSnapshot = SnapshotOut<typeof DeptRestructure>;

export interface IDeptRestructure extends TDeptRestructure {}
export type TDeptRestructureKeys = keyof TDeptRestructureSnapshot & string;
export interface IDeptRestructureSnapshot extends TDeptRestructureSnapshot {}
export const createDeptRestructure = () => types.optional(DeptRestructure, {} as TDeptRestructure);
